module.exports = __webpack_public_path__ + "static/media/june2024-1.400447d9.svg";